import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import Meta from "../common/Meta";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Footer from "../Footer";
import Grid from "@mui/material/Grid";
import {getCommunicationTemplates, getMyCompany, saveMyCompanyTemplates,} from "../common/api/WebApi";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import Card from "@mui/material/Card";
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";
import DataTable from "react-data-table-component";
import BootyPagination from "../common/bootyPagination";
import PageLoading from "../common/PageLoading";
import * as pagination from "../common/pagination";
import {Link, useNavigate} from "react-router-dom";
import {getCookie, setCookie} from "../common/appCookie";
import EmailTemplates from "./EmailTemplates";
import AutomatedTasks from "./AutomatedTasks";


export default function ListCommunicationTemplates(props) {

  const [context, setContext] = useContext(AppContext);
  const navigate = useNavigate();

  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);
  const [render, setRender] = useState(0);
  const [startPage, setStartPage] = useState(0);
  const [templates, setTemplates] = useState([]);
  const [sortOrder, setSortOrder] = useState(1);
  const [sortDir, setSortDir] = useState('asc');
  const [PaginationOptions, setPaginationOptions] = useState(pagination._PaginationOptions);
  const [searchCriteria, setSearchCriteria] = useState();
  const [company, setCompany] = useState();

  useEffect(() => {
    getCompanyTemplates();
    loadCompany();
  }, []);
  const loadCompany = () => {
    getMyCompany().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setCompany(result);
      }
    });
  }
  const getCompanyTemplates = async () => {
    getCommunicationTemplates().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        let defaultTemplate = {
          id: -1,
          templateName: "None"
        }
        result.unshift(defaultTemplate);
        setTemplates(result);
        setLoading(false);
      }
    });
  }

  const handleSort = (column, sortDirection) => {

    setSortOrder(column.id);
    setSortDir(sortDirection);
    setCookie('TEMPLATES_SORT', column.id);
    setCookie('TEMPLATES_SORT_DIR', sortDirection);

    setRender(render + 1);

  };
  const _columns = [
    {
      name: <span className='th'>Name</span>,
      id: 1,
      selector: row => row.templateName,
      cell: row => {
        let link = '/communication/templates/' + row.guid;
        return <Link to={link} className="link"> {row.templateName} </Link>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>Subject</span>,
      id: 2,
      selector: row => row.templateSubject,
      cell: row => {
        return <span>{row.templateSubject}</span>;
      },
      sortable: true,
    },
    {
      name: <span className='th'>View</span>,
      id: 3,
      right: true,
      selector: row => row.guid,
      cell: row => {
        let link = '/communication/templates/' + row.guid;
        return <div><MDButton onClick={() => {
          navigate(link)
        }} size="small" color="primary">View</MDButton></div>
      },
      sortable: false,
    },
  ];

  const [columns, setColumns] = useState(_columns);
  const handleSearchChange = (e) => {
    setSearchCriteria(e.target.value);
  }

  const filteredResults = (items) => {
    if (!searchCriteria || searchCriteria.length === 0) {
      return items;
    }
    let _items = [];
    for (let j in items) {
      let nameCrit = items[j]?.templateName?.toLowerCase();
      let subjectCrit = items[j]?.templateSubject?.toLowerCase();
      let match = nameCrit?.match(searchCriteria?.toLowerCase());
      let match2 = subjectCrit?.match(searchCriteria?.toLowerCase());
      if (match && match.length > 0 || match2 && match2.length > 0) {
        _items.push(items[j]);
      }
    }
    return _items;
  }

  const handlePageChange = (selector, page) => {
    setStartPage(selector);
  };
  const [savingCompany, setSavingCompany] = useState(false);
  const doToast = (msg) => {
    let _context = {...context};
    const toastMessage = msg ? msg : 'Settings successfully saved.';
    _context.toast = {
      message: toastMessage,
      type: 'success'
    }
    setContext({..._context});
  }
  const handleSaveCompanyTemplates = async (company) => {

    setSavingCompany(true);

    let result = await saveMyCompanyTemplates(company);

    setSavingCompany(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      doToast('Templates saved successfully.')
      // setRefreshCompany(true);
      // setOnEdit(false);
    }
  }

  return (
    <DashboardLayout>
      <Meta pageTitle={'Communication Templates'}/>
      <ContextSearchNavbar title="Communication Templates"/>

      <MDBox mt={4}>
        <Grid container spacing={3}>

          {company && <EmailTemplates
            company={company}
            handleSave={handleSaveCompanyTemplates}
            templates={templates}
            savingCompany={savingCompany}
          /> }

          <AutomatedTasks callback={(e)=>{
          }}
          />

          <Grid item xs={12} lg={12}>
            <MDBox pb={3}>
              <MDBox mb={3}>
                <Card>
                  <MDBox p={3} lineHeight={1}>
                    <Grid container>
                      <Grid item xs={12} sm={6}>
                        <h5>
                          Company Templates
                        </h5>
                        <MDInput type="text"
                                 variant="outlined"
                                 value={searchCriteria || ''}
                                 onChange={handleSearchChange}
                                 className="form-control mb-2" id="searchCriteria" aria-describedby="searchCriteria"
                                 label="Search Templates"/>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <MDButton
                          onClick={() => {
                            navigate('/communication/templates/new');
                          }}
                          color="info"
                          size="small"
                          className="pull-right"
                          variant="contained">New Template</MDButton>
                      </Grid>
                    </Grid>
                  </MDBox>
                  {!loading && <DataTable
                    striped
                    columns={columns}
                    keyField={'guid'}
                    data={filteredResults(templates)}
                    onSort={handleSort}
                    highlightOnHover
                    pagination
                    paginationPerPage={20}
                    paginationComponent={BootyPagination}
                    paginationTotalRows={totalRecords}
                    onChangePage={handlePageChange}
                    progressPending={loading}
                    defaultSortFieldId={getCookie('TEMPLATES_SORT') || 1}
                    defaultSortAsc={getCookie('TEMPLATES_SORT_DIR') === 'desc' ? false : true}
                    paginationComponentOptions={PaginationOptions}
                  />}
                </Card>
              </MDBox>

              {loading && <PageLoading/>}

            </MDBox>
          </Grid>
        </Grid>
      </MDBox>


      <Footer mt={5}/>

    </DashboardLayout>
  );
}